<template>
  <div class="settingswrap">
    <DynamicForm :columns="1" 
        :fields="settingsField" @submit="changePassword" 
        :submitting="state.submitting" :errors="state.errors" 
        :success="state.success"/>
  </div>
</template>

<script>
import DynamicForm from '@/components/DynamicForm.vue';
import { reactive } from 'vue';
import call from '@/composables/call';
import { urls } from '@/assets/js/urls';
export default{
  name:"SettingsView",
  components:{DynamicForm},
  setup(){
    const state=reactive({success:false, submitting:false, errors:[],})
    const settingsField= reactive([
      { name: "Change Password", number: "1",data: 
        [{ type: 'password', name: 'newp', label: 'New Password', 
          value: ""  },
          { type: 'password', name: 'conp', label: 'Confirm Password', 
          value: ""  }
        ]
      }
    ])

    function setErrors(res){
      var errors=[];
      Object.keys(res.msg).forEach(key => {
        var e=res.msg[key],er="";
        Object.keys(e).forEach(k => {
          er+=er=="" ? e[k] : ", "+e[k]
        })
        errors.push(er);
      });
      state.errors=errors;
    }

    function changePassword(data){
      state.submitting=true;
      state.errors=[];
      data.changePassword="";
      call({
        url:urls.profile,
        data:data,
        success:(res)=>{
          state.submitting=false;
          if(res.status){
            state.success=true;
          }else{
            setErrors(res)
          }
        },
        error:(res)=>{
          state.submitting=false;
          state.errors=[res]
        }
      })
    }

    return {state, settingsField,changePassword}
  }
}
</script>
<style>
.settingswrap{width:min(90%, 600px); padding:20px 10px}
</style>